<template>
  <TGridItem
    :cols="cols"
    :lg="lg"
  >
    <div class="text-gray-500">
      {{ label }}
    </div>
    <slot>
      <p class="font-semibold">
        {{ displayValue }}
      </p>
    </slot>
  </TGridItem>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    label: string
    value?: number | string
    unit?: string
    // eslint-disable-next-line perfectionist/sort-union-types
    cols?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
    // eslint-disable-next-line perfectionist/sort-union-types
    lg?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12
  }>(),
  {
    value: '',
    unit: '',
    cols: 6,
    lg: 4,
  },
)

const displayValue = computed(() => `${props.value}${props.unit ? ` ${props.unit}` : ''}`)
</script>
